/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  container: {
    '& $panel:first-child': {},
  },

  panel: {
    margin: '0 !important',
    borderRadius: 0,
    borderBottom: '0 !important',
  },

  firstPanel: {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    '& $panelTitleHead': {
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
    },
  },

  panelTitleHead: {
    borderRadius: 0,
  },

  panelTitle: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  panelContent: {},

  divider: {
    margin: '24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0',
    },
  },

  containerPadding: {
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },

  buyingSharesHolder: {
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },

  documentsHolder: {
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },

  buyingPercentageTitle: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
  },

  buyingPercentageHolder: {
    marginTop: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '8px',
      alignItems: 'flex-start',
      '& > *': {
        width: '100% !important',
      },
    },
  },

  percentageSymbol: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    paddingLeft: '8px',
    borderLeft: `1px solid ${theme.palette.primary.borderColor}`,
  },

  totalBuyingPercentageMessage: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },

  totalBuyingPercentage: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
  },

  addRepresentativeHolder: {},

  addRepresentativeBtn: {
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: 500,
  },

  addRepresentativeBtnIcon: {
    width: '9px',
    height: '9px',
  },

  mandatorySign: {
    color: theme.palette.primary.main,
    fontSize: '16px',
    fontWeight: 500,
  },

  representativeTitleAndActionsHolder: {
    display: 'flex',
    alignItems: 'center',
  },

  representativeTitle: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
  },

  representativeGridContainer: {},

  representativeDocumentsTitle: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },

  addBuyerHolder: {
    padding: '24px',
    border: `1px solid ${theme.palette.secondary.disableLightGray}`,
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    [theme.breakpoints.down('xs')]: {
      padding: '16px',
      border: 0,
      flexDirection: 'column',
      gap: '16px',
    },
  },

  addBuyerBtn: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  '@media (max-width: 767px)': {
    addBuyerHolder: {
      padding: '16px',
      border: 0,
      flexDirection: 'column',
      gap: '16px',
    },
  },
});

export default styles;
